module.exports = __webpack_public_path__ + "static/erosion_control_rotated-84fd2096ca57b7dce3866c4f65c77b42.jpg";